import { render, staticRenderFns } from "./Page-Charts.vue?vue&type=template&id=b20ecd7e&scoped=true&"
import script from "./Page-Charts.vue?vue&type=script&lang=js&"
export * from "./Page-Charts.vue?vue&type=script&lang=js&"
import style0 from "./Page-Charts.vue?vue&type=style&index=0&id=b20ecd7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20ecd7e",
  null
  
)

export default component.exports